
  
  export function fetchAllBrands(sort, pagination) {
    let queryString = '';
   
    for (let key in sort) {
     queryString += `${key}=${sort[key]}&`;
   }
     for (let key in pagination) {
       queryString += `${key}=${pagination[key]}&`;
     }
   
     return new Promise(async (resolve) => {
       //TODO: we will not hard-code server URL here
       const response = await fetch(
         '/brands/brands?' + queryString
       );
       const data = await response.json();
       const totalBrands = await response.headers.get('X-Total-Count');
       console.log('data',data);
       resolve({ data: { brands: data, totalBrands: +totalBrands } });
     });
   }
  
   export function updateBrand(update) {
    return new Promise(async (resolve) => {
      const response = await fetch('/brands/'+update.id, {
        method: 'PATCH',
        body: JSON.stringify(update),
        headers: { 'content-type': 'application/json' },
      });
      const data = await response.json();
      // TODO: on server it will only return some info of user (not password)
      resolve({ data });
    });
  }
  
  export function deleteBrand(brandId) {
    return new Promise(async (resolve) => {
      const response = await fetch('/brands/' + brandId, {
        method: 'DELETE',
        headers: { 'content-type': 'application/json' },
      });
      const data = await response.json();
      // TODO: on server it will only return some info of user (not password)
      resolve({ data:brandId});
    });
  }
  
  export function createBrand(brand) {
    return new Promise(async (resolve) => {
      const response = await fetch("/brands", {
        method: "POST",
        body: JSON.stringify(brand),
        headers: { "content-type": "application/json" },
      });
      const data = await response.json();
      // TODO: on server it will only return some info of user (not password)
      resolve({ data });
    });
  }

  export function fetchBrandById(id) {
    return new Promise(async (resolve) => {
      //TODO: we will not hard-code server URL here
      const response = await fetch('/brands/' + id);
      const data = await response.json();
      resolve({ data });
    });
  }